import { AnalyticsInstitutionDashboard } from '../components/analytics-dashboard';
import { CourseAnalyticsRoute } from '../components/course-analytics';
import { CohortAnalyticsRoute } from '../components/cohort-analytics';
import LicenseAnalytics from '../components/license-analytics';

/* @ngInject */
export default function AnalyticsDashboardCtrl(
  $scope,
  $uibModal,
  $controller,
  CourseModel,
  StateManager,
  AlertMessages,
  TimelineModel,
  ConfettiAnimation,
  DashboardResources,
  ConfirmationOverlays,
) {
  $scope.$uibModal = $uibModal;
  $scope.CourseModel = CourseModel;
  $scope.$controller = $controller;
  $scope.StateManager = StateManager;
  $scope.AlertMessages = AlertMessages;
  $scope.TimelineModel = TimelineModel;
  $scope.ConfettiAnimation = ConfettiAnimation;
  $scope.DashboardResources = DashboardResources;
  $scope.AnalyticsInstitutionDashboard = AnalyticsInstitutionDashboard;
  $scope.CourseAnalytics = CourseAnalyticsRoute;
  $scope.CohortAnalytics = CohortAnalyticsRoute;
  $scope.LicenseAnalytics = LicenseAnalytics;
  $scope.ConfirmationOverlays = ConfirmationOverlays;
}
